
import SearchEngine from "/home/runner/work/interact/interact/packages/interact/src/resources/search/combosearch/combosearch.ts";


let properties = {"apiEndpoint":"https://search.combostrap.com/collections/aHR0cHM6Ly9pbnRlcmFjdC5jb21ib3N0cmFwLmNvbS8/search"};
let searchEngineInstance;
try {
    // constructable class
    searchEngineInstance = new SearchEngine(properties)
} catch {
    // callable
    try {
        searchEngineInstance = SearchEngine(properties)
    } catch (e) {
        throw new Error("The default import of the search engine (/home/runner/work/interact/interact/packages/interact/src/resources/search/combosearch/combosearch.ts) is neither a constructor nor a callable", e)
    }
}

export default searchEngineInstance;
